export default __webpack_public_path__ + "static/media/MaskGroup255.52523617.png";